"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const listEvaluatorsGroupsUseCase_1 = __importDefault(require("@/useCases/evaluators/listEvaluatorsGroupsUseCase"));
const listAllEvaluators_1 = __importDefault(require("@/useCases/evaluators/listAllEvaluators"));
const selectors_1 = require("@/store/ducks/evaluators/selectors");
const index_view_1 = __importDefault(require("./index.view"));
function EvaluatorsTableSection() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const tabsData = (0, react_redux_1.useSelector)(selectors_1.siteTabsSelector);
    const areTabsLoading = (0, react_redux_1.useSelector)(selectors_1.areTabsLoadingSelector);
    const firstId = react_1.default.useMemo(() => {
        return tabsData[0]?.id;
    }, [tabsData]);
    react_1.default.useEffect(() => {
        if (firstId) {
            (0, listEvaluatorsGroupsUseCase_1.default)(firstId)(dispatch);
        }
    }, [firstId]);
    react_1.default.useEffect(() => {
        (0, listAllEvaluators_1.default)()(dispatch);
    }, []);
    const evaluatorsGroups = (0, react_redux_1.useSelector)(selectors_1.evaluatorsGroupsSelector);
    const areEvaluatorsGroupsLoading = (0, react_redux_1.useSelector)(selectors_1.areEvaluatorsGroupsLoadingSelector);
    return (react_1.default.createElement(index_view_1.default, { areEvaluatorsGroupsLoading: areEvaluatorsGroupsLoading || areTabsLoading, evaluatorsGroups: evaluatorsGroups }));
}
exports.default = EvaluatorsTableSection;
